import { useState, useEffect } from 'react';

export function usePWAInstall() {
  const [installable, setInstallable] = useState(false);
  const [prompt, setPrompt] = useState(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
      setInstallable(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    const dismissedStored = localStorage.getItem('pwa_install_dismissed');
    if (dismissedStored === '1') setDismissed(true);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const dismiss = () => {
    setDismissed(true);
    try {
      localStorage.setItem('pwa_install_dismissed', '1');
    } catch (_) {}
  };

  return { installable, prompt, dismissed, dismiss };
}
